document.addEventListener("DOMContentLoaded", () => {
  const inlineMenu = document.querySelector(".header__inline-menu");
  const detailsItems = inlineMenu.querySelectorAll("details");

  detailsItems.forEach((item) => {
    const ulElement = item.querySelector("ul");

    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);

      ulElement.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });
});
